module.exports = __webpack_public_path__ + "img/SpaceCoverArt.01cd5366.png";